export default "__VITE_ASSET__B$pWw3f1__"